import { useLocation } from 'react-router-dom';
import { getQuery } from '../utils/bookingUtils';

const useQueryData = () => {
  const searchSection = useLocation().search;
  const activityType = getQuery(searchSection, 'type');
  const smsTemplateId = getQuery(searchSection, 'smsTemplateId');

  return { activityType, smsTemplateId };
};

export default useQueryData;
